import { ProductItem } from '../../Feature/warranty/models/product-item';

/**
 * @param {HTMLElement} element
 */
export function hasId(element) {
  if (!element) return;
  return element.hasAttribute('id') && element.getAttribute('id').length;
}

/**
 * @param {String} name
 */
export function toId(name) {
  if (name !== null && name.split(' ').length > 1) {
    throw new Error('Element has to have only one ID');
  } else {
    return '#' + name;
  }
}

/**
 * @param {Element} elem
 */
export function validateCurrencyField(elem) {
  // get max length on input field - 3 for decimal
  let maxlength = elem.getAttribute('maxlength');
  if (maxlength) {
    maxlength = Number(maxlength) - 3;
  } else {
    // Default value
    maxlength = 9;
  }
  // regex: allow max length if price include decimal ELSE the allow length is max - 3
  // Due to localization will add decimal
  const regex = new RegExp(`^\\d{0,${maxlength}}?[.,]{1}?\\d{0,2}$|^\\d{0,${maxlength}}$`);
  return regex.test(elem.value);
}

/**
 * @param {String} names
 */
export function toClass(names) {
  return '.' + names.split(' ').length > 1 ? names.replace(' ', '.') : names;
}

/**
 * Return the previous/next element of a list.
 * @param {array} list - The list of elements
 * @param activeElement -The active element
 * @param shouldGetNext - Choose to get next or previous element
 * @param isCycleAllowed - Continue to check for next/prev elements?
 * @return {Element|elem} The proper element
 */
export function getNextActiveElement(list, activeElement, shouldGetNext, isCycleAllowed) {
  let index = list.indexOf(activeElement);
  if (index === -1) {
    return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
  }

  const listLength = list.length;

  index += shouldGetNext ? 1 : -1;

  if (isCycleAllowed) {
    index = (index + listLength) % listLength;
  }
  return list[Math.max(0, Math.min(index, listLength - 1))];
}

/**
 * Helper for easily creating DOM-element with properties
 * @param {String} tag - tagname
 * @param {Object} args - properties for tag
 * @param {HTMLElement} target - Append element to a HTMLElement
 * @returns {HTMLElement}
 */
export function createElement(tag, args = {}, target) {
  let elem = document.createElement(tag);

  Object.keys(args).forEach((property) => {
    if (/^(inner|on)\w+$/i.test(property)) {
      elem[property] = args[property];
    } else {
      elem.setAttribute(property, args[property]);
    }
  });

  if (target != null) {
    target.appendChild(elem);
  }

  return elem;
}

export function alignHeight(elem_1, elem_2) {
  if (!elem_1 || !elem_2) return;
  const maxHeight = Math.max(elem_1.offsetHeight, elem_2.offsetHeight);
  elem_1.style.height = maxHeight + 'px';
  elem_2.style.height = maxHeight + 'px';
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

/**
 * Check if we are viewing new BTE Configurator
 */
export function checkIfNewBTE() {
  if (document.querySelector('.configurator_summary')) {
    return true;
  } else {
    return false;
  }
}

export function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

export function getQueryStringParameterByName(name, url = window.location.href) {
  /* eslint-disable-next-line */
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const checkIfDateBeforeToday = (dateYYYYMMDD) =>
  new Date(dateYYYYMMDD).valueOf() < new Date().valueOf();

export const urlParams = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
export const isNullOrWhitespace = (input) => {
  return !input || !input.trim();
};

export const fetchProductData = async ({ apiKey, serialNumber, userId, warrantyApiUrl }) => {
  const postData = {
    UserId: userId,
    APIKey: apiKey,
    SearchWord: serialNumber,
    Skip: 0,
    Take: 1,
    Brands: null,
    SortColumn: null,
    SortDirection: null,
  };

  return fetch(warrantyApiUrl, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { 'Content-type': 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.Warranties && data.Warranties.length > 0) {
        const item = new ProductItem(
          data.Warranties[0].SerialNo,
          data.Warranties[0].Description,
          data.Warranties[0].Patient,
          data.Warranties[0].RepairWarrantyEndDate,
          data.Warranties[0].ModelNo,
          data.Warranties[0].Color,
          false,
          data.Warranties[0].RemakeWarrantyEndDate,
          data.Warranties[0].LossAndDamageWarrantyEndDate,
        );
        return item;
      }
      return null;
    });
};
